<template>

  <div>
    <div class="box-write">
      <div class="wrap-write">
        <div class="title-write">유틸리티명</div>
        <div class="content-write" @click="$router.push(`/item/utility/${utilKey}`)">{{
            this.utilityData.u_name
          }}
        </div>
      </div>
    </div>

    <div class="box-write">
      <div class="wrap-write half">
        <div class="title-write">소유자</div>
        <div class="content-write">{{ this.utilityData.owner_nick }}</div>
      </div>
      <div class="wrap-write half">
        <div class="title-write">연결된 아이템</div>
        <div class="content-write">{{ this.utilityData.i_name }}</div>
      </div>
    </div>

    <div class="box-write">
      <div class="wrap-write">
        <div class="title-write">사용현황</div>
        <div class="content-write">
          {{ this.utilityData.uu_use_cnt }} / {{ this.utilityData.u_use_total }}
        </div>
      </div>
    </div>

    <div class="box-write">
      <div class="wrap-write half">
        <div class="title-write">판매상태</div>
        <div class="content-write">
          {{ returnSellState(this.utilityData.u_sell_start_date, this.utilityData.u_sell_end_date) }}
        </div>
      </div>
      <div class="wrap-write half">
        <div class="title-write">가격</div>
        <div class="content-write">{{ this.utilityData.u_price }}Mg</div>
      </div>
    </div>
  </div>

</template>

<script>

import dateMixins from "@/mixins/dateMixins";

export default {
  name: "UtilityDetailDefaultLayout",
  mixins: [dateMixins],
  components: {},
  inject: [],
  provide() {
    return {};
  },
  props: {
    utilityData: {
      default: {},
    },
    utilKey: {default: 0}
  },
  data() {
    return {};
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {
  },
  beforeUnmount() {
  },
  unmounted() {
  },
  computed: {},
  methods: {
    returnSellState(start, end) {
      let now = this.returnDateTime(new Date());

      if (start > now) {
        return '판매대기';
      } else if (start < now && end > now) {
        return '판매중';
      } else if (end < now) {
        return '판매종료';
      }
    },
  },
  watch: {},
};
</script>

<style lang="scss"></style>
